import { defineCustomElement } from 'vue';
import UiHTMLContent from '~/ui/UiHTMLContent/UiHTMLContent.vue';

// TODO: fix this
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
export const WebUiHTMLContent = defineCustomElement(UiHTMLContent);
customElements.define('ui-html', WebUiHTMLContent);
